import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import mainlogo from "../../assets/mainlogo.png";

import "./Header.css";

const servicesMenu = [
  {
    label: "Google Search Ads",
    to: "/services/google-search-ads",
  },
  {
    label: "SEO",
    to: "/services/seo",
  },
  {
    label: "Local Services Ads",
    to: "/services/local-services-ads",
  },
  {
    label: "Meta Lead Ads",
    to: "/services/meta-lead-ads",
  },
  {
    label: "Web Development",
    to: "/services/web-development",
  },
  {
    label: "AI Video Creation",
    to: "/services/ai-video-creation",
  },
];

const Header = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  const navRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const location = useLocation();

  /* ========================================
     CLOSE MENUS WHEN LOCATION CHANGES
  ======================================== */

  useEffect(() => {
    setHoveredMenu(null);
    setMobileMenuOpen(false);
    setMobileServicesOpen(false);
  }, [location.pathname, location.hash]);

  /* ========================================
     CLOSE DESKTOP DROPDOWN WHEN CLICKING OUTSIDE
  ======================================== */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target)
      ) {
        setHoveredMenu(null);
      }

      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  /* ========================================
     PREVENT BODY SCROLL WHEN MOBILE MENU OPEN
  ======================================== */

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  /* ========================================
     DESKTOP SERVICES HOVER
  ======================================== */

  const handleMouseEnter = () => {
    setHoveredMenu("services");
  };

  const handleMouseLeave = () => {
    setHoveredMenu(null);
  };

  /* ========================================
     NORMAL NAVIGATION CLICK
  ======================================== */

  const handleNormalLinkClick = () => {
    setHoveredMenu(null);
    setMobileMenuOpen(false);
    setMobileServicesOpen(false);
  };

  /* ========================================
     MOBILE HAMBURGER
  ======================================== */

  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
  };

  /* ========================================
     MOBILE SERVICES
  ======================================== */

  const toggleMobileServices = () => {
    setMobileServicesOpen((prev) => !prev);
  };

  return (
    <header className="header">
      <div className="header-container">

        {/* ========================================
            LOGO
        ======================================== */}

        <div className="logo">
          <NavLink
            to="/"
            onClick={handleNormalLinkClick}
          >
            <img
              src={mainlogo}
              alt="Adwiz Media"
              className="main-logo"
            />
          </NavLink>
        </div>

        {/* ========================================
            DESKTOP NAVIGATION
        ======================================== */}

        <nav
          className="navbar"
          ref={navRef}
        >

          {/* HOME */}

          <NavLink
            to="/"
            onClick={handleNormalLinkClick}
          >
            Home
          </NavLink>

          {/* SERVICES DROPDOWN */}

          <div
            className={`nav-dropdown ${
              hoveredMenu === "services" ? "open" : ""
            }`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <button
              type="button"
              className="dropdown-trigger"
            >
              Services
            </button>

            <div className="dropdown-menu">
              {servicesMenu.map((item) => (
                <NavLink
                  key={item.label}
                  to={item.to}
                  className="dropdown-item"
                  onClick={handleNormalLinkClick}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>

          {/* CASE STUDY */}

          <NavLink
            to="/Casestudies"
            onClick={handleNormalLinkClick}
          >
            Case Study
          </NavLink>

          {/* ABOUT */}

          <NavLink
            to="/about"
            onClick={handleNormalLinkClick}
          >
            About
          </NavLink>

          {/* CONTACT */}

          <NavLink
            to="/contact"
            onClick={handleNormalLinkClick}
          >
            Contact
          </NavLink>

        </nav>

        {/* ========================================
            MOBILE RIGHT SIDE
        ======================================== */}

        <div className="mobile-actions">

          {/* HAMBURGER */}

          <button
            type="button"
            className={`hamburger-btn ${
              mobileMenuOpen ? "active" : ""
            }`}
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* BOOK A FREE AUDIT */}

          <a
            href="https://meetings-na2.hubspot.com/adwise-media?uuid=b5338f0a-6ee1-4e2b-88df-ab25699ff81c"
            className="call-btn"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleNormalLinkClick}
          >
            Book A Free Audit
          </a>

        </div>

      </div>

      {/* ========================================
          MOBILE MENU
      ======================================== */}

      <div
        ref={mobileMenuRef}
        className={`mobile-menu ${
          mobileMenuOpen ? "open" : ""
        }`}
      >

        <div className="mobile-menu-inner">

          {/* MOBILE HOME */}

          <NavLink
            to="/"
            className="mobile-nav-link"
            onClick={handleNormalLinkClick}
          >
            <span>Home</span>
          </NavLink>

          {/* MOBILE SERVICES */}

          <div className="mobile-services">

            <button
              type="button"
              className={`mobile-nav-link mobile-services-trigger ${
                mobileServicesOpen ? "active" : ""
              }`}
              onClick={toggleMobileServices}
              aria-expanded={mobileServicesOpen}
            >
              <span>Services</span>

              <span
                className={`mobile-arrow ${
                  mobileServicesOpen ? "rotate" : ""
                }`}
              >
                +
              </span>
            </button>

            <div
              className={`mobile-submenu ${
                mobileServicesOpen ? "open" : ""
              }`}
            >
              {servicesMenu.map((item) => (
                <NavLink
                  key={item.label}
                  to={item.to}
                  className="mobile-submenu-link"
                  onClick={handleNormalLinkClick}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>

          </div>

          {/* CASE STUDY */}

          <NavLink
            to="/Casestudies"
            className="mobile-nav-link"
            onClick={handleNormalLinkClick}
          >
            <span>Case Study</span>
          </NavLink>

          {/* ABOUT */}

          <NavLink
            to="/about"
            className="mobile-nav-link"
            onClick={handleNormalLinkClick}
          >
            <span>About</span>
          </NavLink>

          {/* CONTACT */}

          <NavLink
            to="/contact"
            className="mobile-nav-link"
            onClick={handleNormalLinkClick}
          >
            <span>Contact</span>
          </NavLink>

        </div>
      </div>

      {/* ========================================
          MOBILE OVERLAY
      ======================================== */}

      {mobileMenuOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
      )}

    </header>
  );
};

export default Header;